import { Breadcrumb } from "antd";
import { useEffect, useState } from "react";
import { getLayerBreadcrumb } from "./singleLayerService";
import './SingleLayerTitle.css'

export function SingleLayerTitle({ id }) {
    const [breadcrumbData, setBreadcrumbData] = useState([{ 'title': '...' }]);

    useEffect(() => {

        getLayerBreadcrumb(id).then((response) => {
            if (response) {
                setBreadcrumbData(response.data);
            }
        })

    }, [id]);

    return (
        <div className="mapTitle">
            <div className="mapTitleBox">
                <Breadcrumb
                    separator=""
                    items={breadcrumbData}
                />
            </div>
        </div>
    )
}